const ExportTypes = {
    TOP_ANCHORS: 'TOP_ANCHORS',
    TOP_REF_DOMAINS: 'TOP_REF_DOMAINS',
};

export default ExportTypes;
